import { render, staticRenderFns } from "./ActionIcon.vue?vue&type=template&id=cc11df52&"
import script from "./ActionIcon.vue?vue&type=script&lang=ts&"
export * from "./ActionIcon.vue?vue&type=script&lang=ts&"
import style0 from "./ActionIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
